import React from 'react';
import './App.css';

import Routes from './router/Routes'

export default function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}